import HomeIcon from "@mui/icons-material/Home";
import Nav from "react-bootstrap/Nav";
import { NavLink } from "react-router-dom";

const getHomeLinkStyle = (isActive) => ({
  color: isActive ? "#fff" : "#7b7b93",
  backgroundColor: isActive ? "#0353A4" : "transparent",
  borderRadius: "12px",
  padding: "4px 10px",
  fontWeight: isActive ? 600 : 500,
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  whiteSpace: "nowrap",
  textDecoration: "none",
  flexShrink: 0,
});

const NavbarCenterMenu = ({ pathname, textToShow }) => {
  const isBuyingSide = pathname.startsWith("/BuyingSide");
  const isSellingSide = pathname.startsWith("/SellingSide");

  return (
    <Nav className="navbar-mobile-menu me-auto ms-auto" aria-label="Main navigation">
      <ul className="navbar-nav navbar-mobile-links align-items-center flex-nowrap">
        <>
          {/* Home of business showcase */}
          <li className="nav-item me-1 me-md-2 flex-shrink-0">
            <NavLink
              to="/BuyingSide"
              className="navbar_f smallFont pe-2"
              style={getHomeLinkStyle(isBuyingSide)}
            >
              <HomeIcon
                className="mb-1 smallFonthome"
                style={{ color: isBuyingSide ? "#fff" : "#0353A4" }}
              />
              <span className="navbar-menu-label" style={{ whiteSpace: "nowrap" }}>
                <span className="d-none d-xxl-inline">Home of </span>
                <span>Business Showcase</span>
              </span>
            </NavLink>
          </li>

          {/* Home of business creation */}
          <li className="nav-item me-1 me-md-2 flex-shrink-0">
            <NavLink
              to="/SellingSide"
              className="navbar_f smallFont pe-2"
              style={getHomeLinkStyle(isSellingSide)}
            >
              <HomeIcon
                className="mb-1 smallFonthome"
                style={{ color: isSellingSide ? "#fff" : "#0353A4" }}
              />
              <span className="navbar-menu-label" style={{ whiteSpace: "nowrap" }}>
                <span className="d-none d-xxl-inline">Home of </span>
                <span>Business Creation</span>
              </span>
            </NavLink>
          </li>
        </>

        {/* ACTIVE ROUTE NAME */}
        {textToShow && (
          <li className="nav-item ms-1 ms-lg-2 flex-shrink-0">
            <span
              className="navbar_f smallFont"
              style={{
                color: "#fff",
                backgroundColor: "#0353A4",
                borderRadius: "12px",
                padding: "4px 10px",
                fontWeight: 600,
                display: "inline-flex",
                alignItems: "center",
                whiteSpace: "nowrap",
                flexShrink: 0,
              }}
            >
              {textToShow}
            </span>
          </li>
        )}
      </ul>
    </Nav>
  );
};

export { NavbarCenterMenu };
export default NavbarCenterMenu;